import { render, staticRenderFns } from "./ProductSlotRow.vue?vue&type=template&id=2da4104a&scoped=true"
import script from "./ProductSlotRow.vue?vue&type=script&lang=ts"
export * from "./ProductSlotRow.vue?vue&type=script&lang=ts"
import style0 from "./ProductSlotRow.vue?vue&type=style&index=0&id=2da4104a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da4104a",
  null
  
)

export default component.exports